var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.8289 17.0374L13.3462 12.5155C15.9078 9.53986 15.7623 5.04702 12.9386 2.21716C11.4542 0.729344 9.53304 0 7.58269 0C5.63251 0 3.71118 0.729344 2.22673 2.21716C-0.742245 5.1928 -0.742245 9.97738 2.22673 12.9531C3.71122 14.4409 5.63234 15.1703 7.58269 15.1703C9.3292 15.1703 11.1048 14.5577 12.502 13.3322L16.9847 17.825C17.1012 17.9417 17.2467 18 17.3923 18C17.5378 18 17.6834 17.9417 17.7998 17.825C18.0617 17.6208 18.0617 17.2708 17.8289 17.0374L17.8289 17.0374ZM3.07091 12.1362C0.567627 9.62734 0.567627 5.57214 3.07091 3.0632C4.29338 1.83799 5.89435 1.19604 7.61183 1.19604C9.32927 1.19604 10.9302 1.86712 12.1527 3.0632C14.656 5.5721 14.656 9.62729 12.1527 12.1362C10.9303 13.3615 9.32931 14.0034 7.61183 14.0034C5.89456 14.0034 4.26436 13.3325 3.07091 12.1362Z",
    fill: "#363636"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconSearch);
export default __webpack_public_path__ + "static/media/icon-search.67c6b267cd261f12f930f64a277beb12.svg";
export { ForwardRef as ReactComponent };